import { ref, onMounted, onBeforeUnmount, computed, nextTick } from 'vue'

export function useScreenWidth() {
  const screenWidth = ref(0)

  const calculateScreenWidth = () => {
    screenWidth.value = window.innerWidth
  }

  const isDesktop = computed(() => screenWidth.value >= 1180)
  const isTablet = computed(() => screenWidth.value < 1180)
  const isMobile = computed(() => screenWidth.value < 668)

  onMounted(() => {
    screenWidth.value = window.innerWidth
    nextTick(() => {
      window.addEventListener('resize', calculateScreenWidth)
    })
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', calculateScreenWidth)
  })

  return {
    isDesktop,
    isTablet,
    isMobile,
    screenWidth,
  }
}
